<!-- /* [MATCH-READ-P-POP] 보낸 신청서 보기(개인) */ -->

<template>
  <div v-if="selectedDirectMatching && matchPeople">
    <BasicModal
      :isShowModal="isModal"
      disabledFooter
      @close-modal="$store.commit('directMatching/setHideModalPopup')"
      title="보낸 신청서 보기"
    >
      <div class="popupViewProfile">
        <CorpInfoCard
          v-if="matchPeople.roleName == $role.CORP"
          :data="matchPeople"
        ></CorpInfoCard>
        <UserInfoCard
          v-else-if="matchPeople.roleName == $role.USER"
          :data="matchPeople"
        ></UserInfoCard>

        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <MatchingProcess />

        <section>
          <div class="aRow5">
            <div class="infoBoxForm">
              <div style="margin-bottom: 50px;">
                <h3 class="matchingHeadLine">신청서</h3>
                <LabelInput
                  :label="
                    matchPeople.roleName == $role.CORP
                      ? '신청 대상 기업'
                      : '신청 대상 회원'
                  "
                  :value="matchPeople.name"
                />
                <LabelInput
                  type="textarea"
                  label="매칭신청 사유"
                  :value="selectedDirectMatching.napApplication"
                />
                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">연락처 정보</h3>
                <LabelInput label="신청자 이름" :value="selfAccount.name" />
                <LabelInput label="이메일 주소" :value="selfAccount.email" />
                <LabelInput label="전화번호" :value="selfAccount.phoneNumber" />

                <LabelInput
                  type="textarea"
                  label="전달 내용"
                  :value="selectedDirectMatching.question"
                />
              </div>

              <div class="modal-action">
                <MainButton
                  btnText="확인"
                  @click="$store.commit('directMatching/setHideModalPopup')"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import MatchingProcess from "@/components/items/MatchingProcess.vue";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";
import matchingPopupMixins from "@/mixins/matching-popup-mixins";
import LabelInput from "@/components/formControl/LabelInput.vue";

export default {
  name: "MatchNapPopup",
  components: {
    BasicModal,
    MainButton,
    MatchingProcess,
    CorpInfoCard,
    UserInfoCard,
    LabelInput,
  },
  props: {
    isModal: Boolean,
  },
  mixins: [matchingPopupMixins],
  data() {
    return {
      form: {},
    };
  },
  methods: {
    onClickSubmitForm() {},
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.chip-user {
  font-size: 14px;
  background: #b6cea4;
  line-height: 100%;
  height: 24px;
  padding-top: 2px;
  margin-left: 6px;
  width: 54px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 4px;
}
</style>
